// TODO: Align on the exact levels support.
// Other areas of the code use `rare` and `primary`.
export enum YatLevelDesignation {
    Common = 'common',
    Epic = 'epic',
    Legendary = 'legendary',
}

export enum YatLevelFloor {
    Common = 0,
    Epic = 80,
    Legendary = 90,
}
